import { ExternalLink as ExternalIcon } from 'lucide-react';

export default function ExternalLink({ href, children }: { href: string; children: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 11.5,
        fontWeight: 600,
        color: 'var(--nb-info)',
        textDecoration: 'none',
      }}
    >
      {children}
      <ExternalIcon size={10} aria-hidden />
    </a>
  );
}
